import {BaseConverter} from '../../base/converters/base-converter.converter';
import {IdentityModel} from '../models/identity.model';
import {Identity} from '../../shared/DTO/identity';
import {AgreementConverter} from './agreement.converter';
import {ContactConverter} from './contact.converter';
import {SecurityInfoConverter} from './security-info.converter';
import {SubjectConverter} from './subject.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class IdentityConverter extends BaseConverter<IdentityModel, Identity> {

  constructor(public agreementConverter: AgreementConverter, public contactConverter: ContactConverter, public securityInfoConverter: SecurityInfoConverter, public subjectConverter: SubjectConverter) {
    super();
  }

  convertToDto(model: IdentityModel): Identity {
    if (!model) {
      return;
    }
    return {
      alias: model.alias,
      userType: model.userType
    };
  }

  convertToModel(dto: Identity): IdentityModel {
    if (!dto) {
      return null;
    }

    let model: IdentityModel = new IdentityModel();

    model.agreements = this.agreementConverter.convertToModelList(dto.agreements);
    model.alias = dto.alias;
    model.contacts = this.contactConverter.convertToModelList(dto.contacts);
    model.customerCodeCARA = dto.customerCodeCARA;
    model.domain = dto.domain;
    model.id = dto.id;
    model.nickname = dto.nickname;
    model.password = dto.password;
    model.products = dto.products;
    model.roles = dto.roles;
    model.securityInfo = this.securityInfoConverter.convertToModel(dto.securityInfo);
    model.subject = this.subjectConverter.convertToModel(dto.subject);
    model.userType = dto.userType;
    return model;
  }

}
